import React from 'react'
import { Row, Col, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

const RowLayout = ({
    title,
    description,
    titleSpan = 6,
    contentSpan = 10,
    marginBottom = 10,
    tooltip,
    children
}) => (
    <Row className="form-row-layout" style={{ marginBottom }}>
        <Col className="row-title" span={titleSpan}>
            {title && (
                <label className="title">
                    {title}{' '}
                    {tooltip && (
                        <Tooltip placement="top" title={tooltip}>
                            <QuestionCircleOutlined
                                style={{ color: '#999', cursor: 'help' }}
                            />{' '}
                        </Tooltip>
                    )}
                    :
                </label>
            )}
            <div className="descritpion">{description}</div>
        </Col>
        <Col className="row-content" span={contentSpan}>
            {children}
        </Col>
    </Row>
)

export default RowLayout
